export const USER_PROFILE_TAB_REQUESTS_OWNER_FILTER_KEY = 'owner'

export const USER_PROFILE_TAB_REQUESTS_STAFF_MEMBER_FILTER_KEY = 'staff_member'

export const USER_PROFILE_TAB_REQUESTS_TOTAL_API =
  'idwell-api/api/v3/request/requests/filter/total/'

export const USER_PROFILE_TAB_REQUESTS_QA_NAME = {
  addNew: 'userProfileTabRequestsAddNew',
  export: 'userProfileTabRequestsExport',
  table: 'userProfileTabRequestsTable',
}

export const USER_PROFILE_TAB_REQUESTS_REQUEST_DRAFT_PREFIX =
  'user-requests-request-draft'

export const USER_PROFILE_TAB_REQUESTS_REQUEST_WIZARD_DRAFT_PREFIX =
  'user-requests-request-wizard-draft'
